import { render, staticRenderFns } from "./AssignOrdersTeamStore.vue?vue&type=template&id=823f9284"
import script from "./AssignOrdersTeamStore.vue?vue&type=script&lang=js"
export * from "./AssignOrdersTeamStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports